import type { PurchaseGiftModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import loadable from '@loadable/component';
import { getLogger } from '@cian/logger/shared';
import type * as React from 'react';

export type TPurchaseGiftModalProps = React.ComponentProps<typeof PurchaseGiftModal>;

export const NewbuildingPurchaseGiftModalLoadable = loadable<TPurchaseGiftModalProps>(() => {
  if (process.env.IS_BROWSER_BUILD) {
    return import('@cian/frontend-newbuilding-promo-modal-widget')
      .then(({ PurchaseGiftModal }) => ({ default: PurchaseGiftModal }))
      .catch(
        /* istanbul ignore next */
        error => {
          getLogger().warning(error, {
            domain: 'loadable.chunkLoadFailed',
            message: 'Не удалось загрузить чанк модалки акции «30 000 ₽ за покупку квартиры»',
          });

          return { default: () => null };
        },
      );
  }

  return Promise.resolve({
    default: () => null,
  });
});
